import { render } from "./BasePageHint.vue?vue&type=template&id=a4351c06&scoped=true"
import script from "./BasePageHint.vue?vue&type=script&lang=js"
export * from "./BasePageHint.vue?vue&type=script&lang=js"

import "./BasePageHint.vue?vue&type=style&index=0&id=a4351c06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4351c06"]])

export default __exports__